<template>
    <div class="modal-overlay" @click.self="closeModal">
        <div class="modal-content thank-you-modal">
            <div class="modal-header">
                <h3 class="modal-title">Vielen Dank für Ihr
                    Interesse!</h3>
                <button class="modal-close" @click="closeModal">
                    ×
                </button>
            </div>

            <div class="modal-body">
                <p class="thank-you-message">
                    Ich freue mich über Ihr Interesse und nehme Ihre Anliegen sehr ernst. Ihre Frage ist bei mir
                    eingegangen und ich beantworte sie so bald wie möglich.
                    Bitte haben Sie Verständnis, wenn ich nicht jede Frage veröffentliche – etwa wenn sie bereits
                    beantwortet wurde, nicht zum Thema passt oder keinen Mehrwert für andere Besucherinnen und Besucher
                    bietet.
                </p>
            </div>

            <div class="modal-footer">
                <button class="btn-close-modal" @click="closeModal">
                    schließen
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThankYouModal',
    mounted() {
        document.addEventListener('keydown', this.handleEscape)
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleEscape)
    },
    methods: {
        closeModal() {
            this.$emit('close')
        },
        handleEscape(event) {
            if (event.key === 'Escape') {
                this.closeModal()
            }
        }
    }
}
</script>